import React from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";
import { tableList } from "./task-constants";
import { inputLabelStyles, selectStyles, menuProps } from "./filter-styles";

interface TableSelectProps {
  value: string;
  onChange: (value: string) => void;
}

const TableSelect: React.FC<TableSelectProps> = ({ value, onChange }) => {
  return (
    <FormControl fullWidth required size="small">
      <InputLabel id="table-select-label" sx={inputLabelStyles}>
        Select Table
      </InputLabel>
      <Select
        labelId="table-select-label"
        id="table-select"
        value={value || ""}
        label="Select Table"
        onChange={(e) => onChange(e.target.value)}
        data-testid="table-button-list"
        sx={selectStyles}
        MenuProps={menuProps}
      >
        {tableList.map((table) => (
          <MenuItem key={table.key} value={table.key}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {table.icon}
              <Typography variant="body2">{table.label}</Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default TableSelect;
